import { FETCH_HOME_CATEGORIES, FETCH_HOME_CATEGORIES_IS_LOADING, FETCH_HOME_CATEGORIES_HAS_ERRORED } from '../actions/types';

export function fetchHomeCategories(state = [], action) {
	switch (action.type) {
		case FETCH_HOME_CATEGORIES:
			if(state.length > 0) {
				for (let i = 0; i < state.length; i++) {
					if(String(Object.keys(state[i])) === String(action.items.catId)) {
						state.splice(i, 1);
					}
				}
			}
			const progs = {};
			progs[action.items.catId] = action.items;
			delete progs[action.items.catId].catId;
			return [...state, progs];
		default:
			return state;
	}
}
export function fetchHomeCategoriesHasErrored(state = false, action) {
    switch (action.type) {
        case FETCH_HOME_CATEGORIES_HAS_ERRORED:
            return action.payload;
        default:
            return state;
    }
}
export function fetchHomeCategoriesIsLoading(state = false, action) {
    switch (action.type) {
        case FETCH_HOME_CATEGORIES_IS_LOADING:
            return action.payload;
        default:
            return state;
    }
}
